import moment from 'moment';

type ICommentInfo = IComment.IResponse.ICommentInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

export const changeComment = (
  commentList: ICommentInfo[],
  comment: ICreateOrUpdateComment,
): ICommentInfo[] => {
  const findedIndex = commentList.findIndex(
    (commentItem) => commentItem.id === comment.id,
  );
  if (findedIndex > -1) {
    return commentList.map((commentItem) => {
      if (commentItem.id === comment.id) {
        return {
          id: commentItem.id,
          createdName: commentItem.createdName,
          createdOn: commentItem.createdOn,
          data: comment.comment,
        };
      }
      return {...commentItem};
    });
  } else {
    return addComment(commentList, comment);
  }
};
export const addComment = (
  commentList: ICommentInfo[],
  comment: ICreateOrUpdateComment,
): ICommentInfo[] => {
  const result: ICommentInfo[] = [];
  const newComment: IComment.IResponse.ICommentInfo = {
    id: comment.id,
    data: comment.comment,
    createdName: comment.createdName || '',
    createdOn: '',
  };
  newComment.createdOn = moment().utc().format(`YYYY-MM-DDTHH:mm:ss`); // 仿照后台返回世界标准时间
  result.unshift(newComment);
  return result.concat(commentList);
};
